import Color from "color";
import colors from "PFTheme/tokens/colors";

export const getColorStyles = () => {
  const darkTokens = Object.entries(colors)
    .filter(([key]) => key.endsWith("Dark"))
    .reduce((acc, [key, value]) => {
      const newKey = key.replace(/Dark$/, "");
      const color = new Color(value);
      acc[newKey] = value;
      acc[`${newKey}RGB`] = `${color.red()} ${color.green()} ${color.blue()}`;
      return acc;
    }, {});

  const lightTokens = Object.entries(colors)
    .filter(([key]) => key.endsWith("Light"))
    .reduce((acc, [key, value]) => {
      const newKey = key.replace(/Light$/, "");
      const color = new Color(value);
      acc[newKey] = value;
      acc[`${newKey}RGB`] = `${color.red()} ${color.green()} ${color.blue()}`;
      return acc;
    }, {});

  const rootStyles = `:root {\n${Object.entries(lightTokens)
    .map(([key, value]) => `  --${key}: ${value};`)
    .join("\n")}\n}`;

  const darkStyles = `[data-theme="dark"] {\n${Object.entries(darkTokens)
    .map(([key, value]) => `  --${key}: ${value};`)
    .join("\n")}\n}`;

  return {
    rootStyles,
    darkStyles
  };
};
